// GENERATED by scripts/sync-radio-logos.ts — do not edit by hand.
// Regenerate: scripts/bun.sh run sync:radio-logos
//
// #1739 — where each station's artwork is served from, on OUR origin. The
// picker used to point an <img> straight at api.somafm.com, so every viewer
// handed a third party an IP and a user agent each time the drawer painted.
//
// The map is the sync's receipt: it records what the script actually wrote,
// which is a different fact from what a path template would predict. A station
// that publishes no logo (`logoUrl: null`) carries the SVG tile
// `lib/radioLogoPlaceholder.ts` generates — one implementation, called by the
// sync rather than reproduced anywhere.
//
// `src/__tests__/radioLogoFiles.test.ts` is the gate: every station covered,
// every path a real non-empty file, no orphans, and a logo-less station's tile
// byte-identical to what the generator produces today. It is OFFLINE — the
// point of vendoring is that drawing a logo touches no network, so the gate
// that guards it must not either.

export const RADIO_LOGO_DIR = "/radio-logos";

export const RADIO_LOGO_PATHS: Readonly<Record<string, string>> = {
  bootliquor: "/radio-logos/bootliquor.jpg",
  bossa: "/radio-logos/bossa.jpg",
  brfm: "/radio-logos/brfm.jpg",
  covers: "/radio-logos/covers.jpg",
  defcon: "/radio-logos/defcon.png",
  doomed: "/radio-logos/doomed.png",
  dronezone: "/radio-logos/dronezone.jpg",
  fluid: "/radio-logos/fluid.jpg",
  folkfwd: "/radio-logos/folkfwd.jpg",
  groovesalad: "/radio-logos/groovesalad.png",
  indiepop: "/radio-logos/indiepop.jpg",
  knac: "/radio-logos/knac.png",
  kohina: "/radio-logos/kohina.svg",
  lush: "/radio-logos/lush.jpg",
  metal: "/radio-logos/metal.png",
  missioncontrol: "/radio-logos/missioncontrol.jpg",
  poptron: "/radio-logos/poptron.png",
  reggae: "/radio-logos/reggae.png",
  "rockantenne-metal": "/radio-logos/rockantenne-metal.jpg",
  secretagent: "/radio-logos/secretagent.jpg",
  seventies: "/radio-logos/seventies.jpg",
  sonicuniverse: "/radio-logos/sonicuniverse.jpg",
  spacestation: "/radio-logos/spacestation.jpg",
  u80s: "/radio-logos/u80s.png",
};
